<template>
  <h4 class="card-title mb-3">
    <span class="icon-padding-right-50">
      <i :class="`mdi ${iconImage} ct-card-title`" v-if="!$_utils.isEmpty(iconImage)" />
    </span>
    <span class="ct-padding-right-50" :class="`text-${subTextColor}`" v-if="!$_utils.isEmpty(subTitle)">{{ subTitle }}</span>
    <span :class="`ct-card-${textColor}`">{{ title }}</span>

  </h4>
</template>

<script>
export default {
  props: {
    iconImage: String,
    title: String,
    subTitle: String,
    textColor: String,
    subTextColor: String
  }
}
</script>
